import React, { Profiler, useCallback, useState, useRef } from "react";
import scStyled from "styled-components";
import emotionStyled from "@emotion/styled";
import { makeStyles } from "@material-ui/core/styles";
import queryString from "query-string";
import "./styles.css";

const qs = queryString.parse(window.location.search, { arrayFormat: "comma" });

const NUM_CARDS = Number(qs.cards) || 100;
const TEST_CASES = qs.cases || [
  "emotion-styled",
  "styled-components",
  "mui-make-styles",
  "pure-css"
];

const last = (arr) => arr[arr.length - 1];
const mean = (arr) =>
  arr.reduce((sum, item) => sum + item, 0) / (arr.length || 1);
const round = (value = 0) => Math.round(value * 100) / 100;

const EmotionStyledContainer = emotionStyled.div`
  border: 1px dashed #ccc;
  padding: 4px;
  height: 150px;
  overflow: auto;
  width: 120px;
`;

const ScContainer = scStyled.div`
  border: 1px dashed #ccc;
  padding: 4px;
  height: 150px;
  overflow: auto;
  width: 120px;
`;

const ScCardContainer = scStyled.div`
  border: 1px solid #ccc;
  display: flex;
  margin-bottom: 4px;
  padding: 4px;
  font-size: 12px;
`;

const EmotionStyledCardContainer = emotionStyled.div`
  border: 1px solid #ccc;
  display: flex;
  margin-bottom: 4px;
  padding: 4px;
  font-size: 12px;
`;

const ScItemOne = scStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: red;
`;

const EmotionStyledItemOne = emotionStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: red;
`;

const ScItemTwo = scStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: orange;
`;

const EmotionStyledItemTwo = emotionStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: orange;
`;

const ScItemThree = scStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: yellow;
`;

const EmotionStyledItemThree = emotionStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: yellow;
`;

const ScItemFour = scStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: green;
`;

const EmotionStyledItemFour = emotionStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: green;
`;

const ScItemFive = scStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: blue;
`;

const EmotionStyledItemFive = emotionStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: blue;
`;

const ScItemSix = scStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: violet;
`;

const EmotionStyledItemSix = emotionStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: violet;
`;

const ScItemSeven = scStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: pink;
`;

const EmotionStyledItemSeven = emotionStyled.div`
width: 5px;
height: 5px;
margin-left: 5px;
background: pink;
`;

function ScTable() {
  return (
    <ScContainer>
      {new Array(NUM_CARDS).fill(0).map((_, i) => (
        <ScCardContainer key={i}>
          Card {i}
          <ScItemOne />
          <ScItemTwo />
          <ScItemThree />
          <ScItemFour />
          <ScItemFive />
          <ScItemSix />
          <ScItemSeven />
        </ScCardContainer>
      ))}
    </ScContainer>
  );
}

const sharedItemStyles = {
  width: "5px",
  height: "5px",
  marginLeft: "5px"
};

const useStaticStyles = makeStyles({
  container: {
    border: "1px dashed #ccc",
    padding: "4px",
    height: "150px",
    overflow: "auto",
    width: "120px"
  },
  cardContainer: {
    border: "1px solid #ccc",
    display: "flex",
    marginBottom: "4px",
    padding: "4px",
    fontSize: "12px"
  },
  itemOne: {
    ...sharedItemStyles,
    background: "red"
  },
  itemTwo: {
    ...sharedItemStyles,
    background: "orange"
  },
  itemThree: {
    ...sharedItemStyles,
    background: "yellow"
  },
  itemFour: {
    ...sharedItemStyles,
    background: "green"
  },
  itemFive: {
    ...sharedItemStyles,
    background: "blue"
  },
  itemSix: {
    ...sharedItemStyles,
    background: "violet"
  },
  itemSeven: {
    ...sharedItemStyles,
    background: "pink"
  }
});

function MuiStaticTable(props) {
  const classes = useStaticStyles();
  return (
    <div className={classes.container}>
      {new Array(NUM_CARDS).fill(0).map((_, i) => (
        <div className={classes.cardContainer} key={i}>
          Card {i}
          <div className={classes.itemOne} />
          <div className={classes.itemTwo} />
          <div className={classes.itemThree} />
          <div className={classes.itemFour} />
          <div className={classes.itemFive} />
          <div className={classes.itemSix} />
          <div className={classes.itemSeven} />
        </div>
      ))}
    </div>
  );
}

function EmotionStyledTable(props) {
  return (
    <EmotionStyledContainer>
      {new Array(NUM_CARDS).fill(0).map((_, i) => (
        <EmotionStyledCardContainer key={i}>
          Card {i}
          <EmotionStyledItemOne />
          <EmotionStyledItemTwo />
          <EmotionStyledItemThree />
          <EmotionStyledItemFour />
          <EmotionStyledItemFive />
          <EmotionStyledItemSix />
          <EmotionStyledItemSeven />
        </EmotionStyledCardContainer>
      ))}
    </EmotionStyledContainer>
  );
}

function PureCss(props) {
  return (
    <div className="container">
      {new Array(NUM_CARDS).fill(0).map((_, i) => (
        <div className="card-container" key={i}>
          Card {i}
          <div className="item-one" />
          <div className="item-two" />
          <div className="item-three" />
          <div className="item-four" />
          <div className="item-five" />
          <div className="item-six" />
          <div className="item-seven" />
        </div>
      ))}
    </div>
  );
}

const timings = {};

function TestCase(props) {
  const { Component, name } = props;
  const timeElementRef = useRef();

  const onRender = useCallback(
    (
      id, // the "id" prop of the Profiler tree that has just committed
      phase, // either "mount" (if the tree just mounted) or "update" (if it re-rendered)
      actualDuration, // time spent rendering the committed update
      baseDuration, // estimated time to render the entire subtree without memoization
      startTime, // when React began rendering this update
      commitTime, // when React committed this update
      interactions // the Set of interactions belonging to this update
    ) => {
      if (!timings[name]) {
        timings[name] = { mount: [], rerender: [] };
      }
      const thisTimings = timings[name];

      if (phase === "mount") {
        thisTimings.mount.push(baseDuration);
      } else {
        thisTimings.rerender.push(baseDuration);
      }

      const lastMount = round(last(thisTimings.mount));
      const lastRerender = round(last(thisTimings.rerender));
      const meanMount = round(mean(thisTimings.mount));
      const meanRerender = round(mean(thisTimings.rerender));

      timeElementRef.current.textContent = `
Last mount: ${lastMount}ms
Mean mount: ${meanMount}ms
Last rerender: ${lastRerender}ms
Mean rerender: ${meanRerender}ms

`;
    },
    [name]
  );

  return (
    <Profiler id={name} onRender={onRender}>
      <div className="test-case">
        <div className="name">{name}</div>
        <div className="time" ref={timeElementRef}></div>
        <Component />
      </div>
    </Profiler>
  );
}

function TestSuite() {
  return (
    <div className="suite">
      <div>
        {TEST_CASES.includes("emotion-styled") && (
          <TestCase name="Emotion styled" Component={EmotionStyledTable} />
        )}
        {TEST_CASES.includes("styled-components") && (
          <TestCase name="Styled Components" Component={ScTable} />
        )}
        {TEST_CASES.includes("mui-make-styles") && (
          <TestCase name="MUI makeStyles" Component={MuiStaticTable} />
        )}
        {TEST_CASES.includes("pure-css") && (
          <TestCase name="Pure CSS" Component={PureCss} />
        )}
      </div>
    </div>
  );
}

export default function App() {
  const [runCount, setRunCount] = useState(0);
  const onClickRun = useCallback(() => {
    let nextRunCount = runCount + 1;
    setRunCount(-1);
    setTimeout(() => {
      setRunCount(nextRunCount);
    }, 50);
  }, [runCount]);

  const onClickRerender = useCallback(() => {
    let nextRunCount = runCount + 1;
    setRunCount(nextRunCount);
  }, [runCount]);

  return (
    <div className="App">
      <h1>CSS-in-JS Perf Comparison</h1>
      <p>
        Renders a list of {NUM_CARDS} cards using various styling strategies,
        and uses React's &lt;Profiler&gt; component to measure render time.
      </p>
      <p>Click the button below to begin.</p>
      <button onClick={onClickRun} disabled={runCount === -1}>
        {runCount > 0 ? "Run Again" : "Run Test Suite"}
      </button>
      <button
        onClick={onClickRerender}
        disabled={runCount <= 0}
        style={{ marginLeft: 10 }}
      >
        Rerender
      </button>
      <br />
      <br />
      {runCount > 0 && <TestSuite />}
    </div>
  );
}
